import React, { useState, useEffect } from 'react'
import axios from 'axios'
import { KTIcon } from '../../../../../../_metronic/helpers'
// UnitMeasurementModalForm
// import UnitMeasurementModalForm from '../form-edit-modal/FacilitiesModalForm'
import WCC from '../form-edit-modal/WCC'
import { KTCard } from '../../../../../../_metronic/helpers'
import SustainabilityDeclarationForm from './test'

interface User {
  userId: string
  userProfile: string
  userName: string
  totalDue: number
  totalBalance: number
  totalPaid: number
  totalSupplied: number
  transactions: any[]
  date: string
  recipientInfo: {
    name: string
    // add other recipient properties as needed
  }
  quantity: number
  countryOfOrigin: string
  productName: string
  uniqueNo: string
}

interface ApiResponse {
  data: User[]
  meta: {
    pageSize: number
    currentPage: number
  }
  totalStock: number
}

const WCC2 = () => {

  const [showAddModal, setShowAddModal] = useState(false)
  const [users, setUsers] = useState<User[]>([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState('')
  const [searchQuery, setSearchQuery] = useState('')
  const [filteredUsers, setFilteredUsers] = useState<User[]>([])

  const [showModal, setShowModal] = useState(false)
  const [selectedUser, setSelectedUser] = useState<User | null>(null)
  const handleEditClick = (user: User) => {
    setSelectedUser(user)
    setShowModal(true)
  }

  // Fetch data from API
  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true)
        const response = await axios.get<ApiResponse>(
          `${process.env.REACT_APP_BASE_API_URL}isccSustainablities?isFromPickupPoint=true`,
          {
            headers: {
              'accept': 'application/json',
              'app-id': '3',
              'client-id': '101212',
            }
          }
        )

        const userData = response.data.data || []
        setUsers(userData)
        setFilteredUsers(userData)
        setLoading(false)
      } catch (err) {
        console.error('API Error:', err)
        setError('Failed to fetch data')
        setLoading(false)
      }
    }

    fetchData()
  }, [])

  // Handle search
  useEffect(() => {
    if (searchQuery === '') {
      setFilteredUsers(users)
    } else {
      const filtered = users.filter(user =>
        user.userName?.toLowerCase().includes(searchQuery.toLowerCase()) ||
        user.userId?.toLowerCase().includes(searchQuery.toLowerCase())
      )
      setFilteredUsers(filtered)
    }
  }, [searchQuery, users])

  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchQuery(e.target.value)
  }

  if (loading) {
    return (
      <div style={{ padding: '20px', textAlign: 'center' }}>
        <div>Loading...</div>
      </div>
    )
  }

  return (
    <KTCard>
      <div style={{ padding: '20px' }}>
        {/* Search Box */}
        <div style={{
          marginBottom: '20px',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}>
          <div style={{ position: 'relative', width: '300px' }}>
            <svg
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              style={{
                position: 'absolute',
                left: '10px',
                top: '50%',
                transform: 'translateY(-50%)',
                color: '#6B7280',
              }}
            >
              <circle cx="11" cy="11" r="8" />
              <line x1="21" y1="21" x2="16.65" y2="16.65" />
            </svg>
            <input
              type="text"
              placeholder="Search users..."
              value={searchQuery}
              onChange={handleSearch}
              style={{
                width: '100%',
                height: '40px',
                padding: '8px 8px 8px 35px',
                fontSize: '14px',
                border: '1px solid #E5E7EB',
                borderRadius: '6px',
                outline: 'none',
                backgroundColor: 'white',
              }}
            />
          </div>
          <button
            onClick={() => setShowAddModal(true)}
            // style={{ backgroundColor: "#12b886", }}
            className="btn btn-primary"
          >
            <span>+ </span>
            Add new
          </button>
        </div>

        {/* Table */}
        <div style={{ overflowX: 'auto' }}>






          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr style={{ backgroundColor: '#333333', color: 'white' }}>
                <th style={{ padding: '15px', textAlign: 'left', fontWeight: 'bold' }}>S.N</th>
                <th style={{ padding: '15px', textAlign: 'left', fontWeight: 'bold' }}>DATE</th>
                <th style={{ padding: '15px', textAlign: 'left', fontWeight: 'bold' }}>DECLARATION NUMBER</th>
                {/* <th style={{ padding: '15px', textAlign: 'left', fontWeight: 'bold' }}>UNIQUE ID</th> */}
                <th style={{ padding: '15px', textAlign: 'left', fontWeight: 'bold' }}>RECIPIENT</th>
                <th style={{ padding: '15px', textAlign: 'left', fontWeight: 'bold' }}>PRODUCT NAME</th>
                <th style={{ padding: '15px', textAlign: 'left', fontWeight: 'bold' }}>QUANTITY</th>
                <th style={{ padding: '15px', textAlign: 'left', fontWeight: 'bold' }}>COUNTRY</th>
                <th style={{ padding: '15px', textAlign: 'left', fontWeight: 'bold' }}>VIEW</th>
              </tr>
            </thead>
            <tbody>
              {filteredUsers.length > 0 ? (
                filteredUsers.map((user, index) => (
                  <tr
                    key={user.userId}
                    style={{
                      backgroundColor: 'white'
                    }}
                  >
                    <td style={{ padding: '12px' }}>{index + 1}</td>
                    <td style={{ padding: '12px' }}>
                      {user.date ? new Date(Number(user.date)).toLocaleDateString('en-CA') : 'N/A'}
                    </td>
                    <td style={{ padding: '12px', fontWeight: '500' }}>
                      {user?.uniqueNo}
                    </td>
                    <td style={{ padding: '12px' }}>
                      {user?.recipientInfo?.name}
                    </td>
                    <td style={{ padding: '12px' }}>
                      {user?.productName}
                    </td>
                    <td style={{ padding: '12px' }}>
                      {user?.quantity ? user.quantity.toFixed(2) : '0.00'}
                    </td>
                    <td>
                      {user?.countryOfOrigin}
                    </td>
                    <td style={{ padding: '12px' }}>
                      <div style={{ cursor: 'pointer' }} onClick={() => handleEditClick(user)}>

                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td
                    colSpan={9}
                    style={{
                      padding: '40px',
                      textAlign: 'center',
                      color: '#9ca3af',
                      fontSize: '14px'
                    }}
                  >
                    No matching records found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        {/* Add this before the closing </div> */}
        {/* Custom Modal */}
        {showModal && (
          <div
            style={{
              position: 'fixed',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: 'rgba(0, 0, 0, 0.5)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              zIndex: 1000
            }}
            onClick={() => setShowModal(false)}
          >
            <div
              style={{
                backgroundColor: 'white',
                padding: '20px',
                borderRadius: '8px',
                maxWidth: '800px',
                width: '90%',
                maxHeight: '80vh',
                overflowY: 'auto'
              }}
              onClick={(e) => e.stopPropagation()}
            >
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
                <h3>Edit user</h3>
                <button
                  onClick={() => setShowModal(false)}
                  style={{ background: 'none', border: 'none', fontSize: '24px', cursor: 'pointer' }}
                >
                  ×
                </button>
              </div>

              <WCC
                isUserLoading={false}
                user={selectedUser}
                onClose={() => setShowModal(false)}
              />
            </div>
          </div>
        )}



        {/* Add New Modal */}
        {showAddModal && (
          <div
            style={{
              position: 'fixed',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: 'rgba(0, 0, 0, 0.5)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              zIndex: 1000
            }}
            onClick={() => setShowAddModal(false)}
          >
            <div
              style={{
                backgroundColor: 'white',
                padding: '20px',
                borderRadius: '8px',
                maxWidth: '900px',
                width: '90%',
                maxHeight: '100vh',
                overflowY: 'auto'
              }}
              onClick={(e) => e.stopPropagation()}
            >
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
                <h3></h3>
                <button
                  onClick={() => setShowAddModal(false)}
                  style={{ background: 'none', border: 'none', fontSize: '24px', cursor: 'pointer' }}
                >
                  ×
                </button>
              </div>

              {/* Replace YourNewComponent with your actual component */}
              <SustainabilityDeclarationForm
                onClose={() => setShowAddModal(false)}
              />
            </div>
          </div>
        )}
      </div>
    </KTCard>
  )
}

export { WCC2 }